export default __webpack_public_path__ + "static/media/008-Soft drink.f5b74825.svg";